import "./Header.scss";

import HeaderLogo from "../../assets/images/header-logo.png";
import React from "react";

export default function Header() {
	const handleNavClick = (e) => {
		e.preventDefault(); // Prevent default anchor behavior

		try {
			const targetHref = e.target.getAttribute("href");
			let targetPosition;

			// Handle the "Home" link to scroll to the top
			if (targetHref === "/") {
				return;
			}

			const targetElement = document.querySelector(targetHref);
			if (!targetElement) {
				console.warn(
					`Target element not found for selector: ${targetHref}`
				);
				return;
			}

			const headerElement = document.querySelector(".header");
			const headerHeight = headerElement ? headerElement.offsetHeight : 0;

			// Use offsetTop to get the element's position relative to the start of the scrollable content.
			// Subtract the header height to leave space for the fixed header.
			targetPosition = targetElement.offsetTop - headerHeight;

			// Check if our custom scroll function from the hijack container exists
			if (typeof window.smoothScrollTo === "function") {
				window.smoothScrollTo(targetPosition);
			} else {
				// Fallback to native browser scroll if the hijacker isn't active
				console.warn(
					"smoothScrollTo not available, falling back to native scroll."
				);
				window.scrollTo({ top: targetPosition, behavior: "smooth" });
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="header">
			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					<a href="/" className="header-logo-link">
						<img
							className="header-logo"
							src={HeaderLogo}
							alt="Header Logo"
							width="60"
							height="37"
						/>
					</a>
				</div>

				<div className="header-center">
					<nav className="header-nav">
						<ul className="header-nav-list">
							<li>
								<a
									href="/"
									className="active"
									onClick={handleNavClick}
								>
									Home
								</a>
							</li>
							<li>
								<a
									href="#our-features"
									onClick={handleNavClick}
								>
									Our Features
								</a>
							</li>
							<li>
								<a href="#roadmap" onClick={handleNavClick}>
									Roadmap
								</a>
							</li>
						</ul>
					</nav>
				</div>

				<div className="header-right"></div>
			</div>
		</div>
	);
}
